import React from 'react';

export interface IconProps {
  className?: string;
}

export function DefaultIcon({ className }: IconProps) {
  return (
    <svg
      width="42"
      height="41"
      viewBox="0 0 42 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M41.065 20.0145C41.0139 14.6978 38.9204 9.68774 35.1419 5.93022C31.3379 2.12159 26.2574 0 20.8705 0C15.4835 0 10.403 2.09603 6.57344 5.93022C2.76941 9.73886 0.650391 14.8256 0.650391 20.219C0.650391 25.6124 2.74388 30.6991 6.57344 34.5078C10.3009 38.2397 15.2282 40.3102 20.462 40.4124H20.8449C26.2318 40.4124 31.3124 38.3164 35.1164 34.4822L35.8057 33.7921L32.691 30.6736L32.0017 31.3637C29.0146 34.3544 25.0574 35.9903 20.8194 35.9903C16.5814 35.9903 12.6241 34.3544 9.63708 31.3637C6.65003 28.3731 5.01609 24.4111 5.01609 20.1679C5.01609 15.9247 6.65003 11.9627 9.63708 8.97202C12.6241 5.98135 16.5814 4.34542 20.8194 4.34542C25.0574 4.34542 29.0146 5.98135 32.0017 8.97202C34.4526 11.4259 36.01 14.5699 36.4695 17.9696H33.1761C32.7421 15.439 31.5422 13.1385 29.704 11.2981C27.3296 8.9209 24.1639 7.61727 20.8194 7.61727C17.4749 7.61727 14.3091 8.9209 11.9348 11.2981C9.5605 13.6753 8.25844 16.8193 8.25844 20.1679C8.25844 23.5164 9.5605 26.686 11.9348 29.0376C14.3091 31.3893 17.3217 32.6674 20.5896 32.7185H20.8194C24.1639 32.7185 27.3296 31.4149 29.704 29.0376L30.3933 28.3475L27.3041 25.2546L26.6148 25.9447C25.083 27.4784 23.015 28.3475 20.8449 28.3475C18.6748 28.3475 16.6069 27.504 15.0751 25.9447C14.0538 24.9478 13.3645 23.6953 12.9816 22.3661H41.0395V19.9889M20.8449 17.9952H12.9816C13.3645 16.666 14.0538 15.439 15.0751 14.4166C16.6069 12.8829 18.6748 12.0394 20.8449 12.0394C23.015 12.0394 25.083 12.8829 26.6148 14.4166C27.636 15.439 28.3253 16.666 28.7083 17.9952H20.8449Z"
        fill="#00416B"
      />
    </svg>
  );
}
